import type { ComponentProps } from "react";

import { CHIP, CHIP_TONE, type ChipTone } from "@/lib/chips";
import { cn } from "@/lib/utils";

interface ChipProps extends ComponentProps<"span"> {
  /** What the chip says decides its colours (`CHIP_TONE`); `neutral` by default. */
  tone?: ChipTone;
}

/**
 * A small label in a table cell, as on the Tools page: Lezen and Schrijven, a
 * role, a team, Binnenkort, Geblokkeerd. Square-ish, small text, never wraps.
 */
export function Chip({ tone = "neutral", className, ...props }: ChipProps) {
  return <span className={cn(CHIP, CHIP_TONE[tone], className)} {...props} />;
}
